exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-btn[data-v-2b252b60] {\n  display: inline-block;\n  padding: 2px 5px;\n  color: #1890ff;\n  cursor: pointer;\n}\n.card-form[data-v-2b252b60] {\n  width: 700px;\n  padding: 20px;\n  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n[data-v-2b252b60] .ant-input-affix-wrapper textarea {\n  white-space: pre-wrap !important;\n}\n.rich-text-show[data-v-2b252b60] {\n  height: 50px;\n  max-height: 100px;\n  margin-bottom: 10px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n}\n", ""]);

// exports
